export default __webpack_public_path__ + "ef4a9e1b2d935c836e7b93590d4591ec.svg";